// extracted by mini-css-extract-plugin
export default {"static":"styles_static__EottR","fabExpanded":"styles_fabExpanded__gz6C+","fabOpenButton":"styles_fabOpenButton__UR6Ht"};